import { render, staticRenderFns } from "./EditPersonalInfo.vue?vue&type=template&id=597a7088&"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonalInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports